import { useCallback, useState } from 'react';

export interface UsePortfolioModalOptions {
  initialProjectId?: string;
}

/**
 *
 * Usage:
 *
 const { openPortfolioModal } = usePortfolioModal();
 openPortfolioModal($projectId) // In order to open the modal on specific portfolio project
 openPortfolioModal(undefined, true) // In order to open the modal with intro video allowing to navigate to and from it to the rest of portfolio projects
 *
 *
 */
export const usePortfolioModal = ({ initialProjectId }: UsePortfolioModalOptions = {}) => {
  const [currentProjectId, setCurrentProjectId] = useState<string | undefined>(initialProjectId);
  const [withIntroVideo, setWithIntroVideo] = useState(false);

  const openPortfolioModal = useCallback((projectId?: string, withIntroVideo = false) => {
    setCurrentProjectId(projectId);
    setWithIntroVideo(withIntroVideo);
  }, []);

  return {
    openPortfolioModal,
    currentProjectId,
    setCurrentProjectId,
    setWithIntroVideo,
    withIntroVideo,
  };
};
